import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { Logger } from "../../infra/logger/logger";
import { ParameterInputFilter } from "domain/models/parameter-input-filter";
import parameterRepository from "infra/repositories/parameter-repository";

export const useWorkLocationsByFilter = (filter: ParameterInputFilter) => {
  const logger = Logger.getInstance();

  return useQuery({
    queryKey: ["workLocations", filter],
    queryFn: async () => {
      try {
        const result = await parameterRepository.getAll(filter);
        return result;
      } catch (error: any) {
        if (error instanceof AxiosError) {
          logger.error(
            error.response?.data.metadata.errors[0],
            error.response?.data.metadata
          );
          throw new Error(error.response?.data.metadata.errors);
        }
        throw error;
      }
    },
    retry: Number(process.env.REACT_APP_QUERY_RETRY) || 5,
    staleTime: 0,
  });
};